import React, { useId } from "react";

const SwitchRow = ({ label, description, checked, onChange }) => {
  // Generate unique ID for accessibility
  const inputId = `switch-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="grid grid-cols-3 mb-8 gap-6 ">
      <div>
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-gray-700 cursor-pointer"
        >
          {label}
        </label>
        <p className="text-xs text-gray-500 mt-1">{description}</p>
      </div>

      {/* Switch container */}
      <div>
        <label
          htmlFor={inputId}
          className="flex  gap-3 cursor-pointer justify-self-end"
        >
          <input
            type="checkbox"
            id={inputId}
            className="hidden"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
          />
          {/* Track and thumb */}
          <div className="relative inline-block w-11 h-6">
            <div
              className={`w-full h-full rounded-full transition-colors duration-200 ${
                checked ? "bg-gray-700" : "bg-gray-300"
              }`}
            ></div>
            <div
              className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-sm transition-transform duration-200 ${
                checked ? "translate-x-5" : ""
              }`}
            ></div>
          </div>
          {/* ON/OFF text */}
          <span className="text-sm text-gray-600">
            {checked ? "ON" : "OFF"}
          </span>
        </label>
      </div>
    </div>
  );
};

export default SwitchRow;
